import React from 'react';
import { Box, Typography, FormControlLabel, Grid } from '@mui/material';
import Switch from '../Switch';

interface Toolbar {
  title: string;
  caption: string;
  filter?: boolean;
  hidable?: boolean;
  hide?: boolean;
  hideToggle?: boolean;
  onChange?: () => void;
  hideFilterChange?: () => void;
  handleHide?: () => void;
  hidePendingTasks?: boolean
}

const SepToolbar: React.FC<Toolbar> = ({
  title,
  caption,
  hidable,
  hide,
  filter,
  hideToggle,
  onChange,
  handleHide,
  hideFilterChange,
  hidePendingTasks
}: Toolbar) => {
  const display = hideToggle ? { display: 'none' } : null;
  return (
    <>
      <Grid
        container
        xs= {12}
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          flexDirection:{
            xs: 'column',
            md: 'row',
          },
          pl: 3,
          pr: 4,
          py: 1,
        }}
      >
        <Grid>
          <Typography sx={{ font: 'normal normal 600 18px/24px Open Sans;' }}>
            {title}
            &nbsp;&nbsp;
            {hidable &&
              (hide ? (
                <i className="fa-regular fa-angle-up" onClick={handleHide}></i>
              ) : (
                <i
                  className="fa-regular fa-angle-down"
                  onClick={handleHide}
                ></i>
              ))}
          </Typography>
          <Typography variant="caption">{caption}</Typography>
        </Grid>
        <Grid sx={{display: 'flex', flexDirection:{ xs: 'column', md: 'row' }, justifyContent: { xs: 'flex-start', md: 'center' }, alignItems: { xs: 'flex-start', md: 'center' }, mt: { xs: 2, md: 0 } }}>
        <FormControlLabel
          control={<Switch checked={hidePendingTasks} onChange={hideFilterChange} />}
          sx={{ mr: { xs: 0, md: 2 }, display, mb: { xs: 1, md: 0 } }}
          label={
            <Typography
              sx={{ font: 'normal normal normal 14px/22px Open Sans;', mr: { xs: 3, md: 2 }, ml: 0 }}
            >
              Hide Locked Tasks
            </Typography>
          }
          labelPlacement="start"
        />
        <FormControlLabel
          control={<Switch checked={filter} onChange={onChange} />}
          sx={{ alignItems: 'flex-end', display }}
          label={
            <Typography
              sx={{ font: 'normal normal normal 14px/22px Open Sans;', mr: 2, ml: 0 }}
            >
              Hide Complete Tasks
            </Typography>
          }
          labelPlacement="start"
        />
        </Grid>
      </Grid>
    </>
  );
};

export default SepToolbar;
